import React from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { AppView, CardView, withAnimatedNavigationHeader } from 'design-system';
import { rem, SCROLL_INDICATOR_INSETS } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { formatPercentageToMinimum2DecimalPlaces } from 'utils';
import Animated from 'react-native-reanimated';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { isWeb } from '../../../constants';
const SUBTITLE_MAP = {
    Holdings: 'Shows the fund\u2019s top 10 holdings',
    Assets: 'Breakdown of the fund by asset class',
    Regions: 'Breakdown of the fund by region',
    Sectors: 'Breakdown of the fund by sector',
    Currencies: 'Breakdown of the fund by currency',
};
const FundAllocationDetailScreen = withAnimatedNavigationHeader((props) => {
    const styles = useStyles(styleSet);
    const { title, items } = props.route.params;
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const marginBottom = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    const subtitle = SUBTITLE_MAP[title] ?? '';
    return (<AppView withFrame={false}>
        <Animated.ScrollView onScroll={props.scrollHandler} contentContainerStyle={marginBottom} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          {subtitle ? (<Text TextThin-14 Secondary style={styles.subtitle}>
              {subtitle}
            </Text>) : null}
          <CardView noMarginBottom>
            <View style={styles.content}>
              {items.map((item, index) => (<View key={`${item.name}-${index}`} style={styles.row}>
                  <Text Text-14 flex>
                    {item.name}
                  </Text>
                  <Text NumbersThin-14 Secondary>
                    {formatPercentageToMinimum2DecimalPlaces(item.percentage)}
                  </Text>
                </View>))}
            </View>
          </CardView>
        </Animated.ScrollView>
      </AppView>);
}, ({ route, colors }) => ({
    title: route.params.title,
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default FundAllocationDetailScreen;
const styleSet = createStyleSheets(() => ({
    subtitle: {
        paddingHorizontal: rem(16),
        paddingTop: rem(8),
    },
    content: {
        paddingHorizontal: rem(16),
        paddingVertical: rem(4),
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: rem(12),
        gap: rem(16),
    },
}));
